export const MOCK_PORTFOLIO_ALERTS_COMPONENT_DATA = {
	id: 'portfolio.alerts',
	tabs: [
		{
			config: {
				id: 'portfolio.flags',
				title: null,
				extractorConfig: {
					portfolioName: {
						label: null,
						infoBubble: null,
						extractor: {
							stores: [
								'details',
								'associatedPortfolios'
							],
							extractors: {
								PORTFOLIO: {
									storeConfig: [
										'details',
										'associatedPortfolios'
									]
								},
								MODEL_PORTFOLIO: {
									storeConfig: [
										'details'
									],
									expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
								},
								FALLBACK: {
									storeConfig: [
										'details'
									],
									expression: 'name'
								}
							},
							dataPaths: [
								'details,associatedPortfolios',
								'details,associatedPortfolios',
								'details,associatedPortfolios'
							]
						},
						id: 'name',
						labelFormatter: {},
						formatters: [],
						visible: true
					},
					tableDataTransform: {},
					firstColumnTitle: null,
					columns: [
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'flags',
								defaultValue: null
							},
							id: 'portfolioFlags',
							labelFormatter: {},
							formatters: [],
							visible: true
						},
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'originNotTradableSecurities',
								defaultValue: null
							},
							id: 'securityFlags',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'baseModelWasDirty',
								defaultValue: null
							},
							id: 'dirtyFlag',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							infoBubble: null,
							extractor: {
								stores: [
									'details',
									'associatedPortfolios'
								],
								extractors: {
									PORTFOLIO: {
										storeConfig: [
											'details',
											'associatedPortfolios'
										]
									},
									MODEL_PORTFOLIO: {
										storeConfig: [
											'details'
										],
										expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
									},
									FALLBACK: {
										storeConfig: [
											'details'
										],
										expression: 'name'
									}
								},
								dataPaths: [
									'details,associatedPortfolios',
									'details,associatedPortfolios',
									'details,associatedPortfolios'
								]
							},
							id: 'name',
							labelFormatter: {},
							formatters: [],
							visible: true
						}
					]
				}
			},
			tableData: [
				{
					headersX: [
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'flags',
									defaultValue: null
								},
								id: 'portfolioFlags',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'originNotTradableSecurities',
									defaultValue: null
								},
								id: 'securityFlags',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'baseModelWasDirty',
									defaultValue: null
								},
								id: 'dirtyFlag',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						}
					],
					headersY: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					cells: [
						[
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'flags',
										defaultValue: null
									},
									id: 'portfolioFlags',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								},
								parent: null,
								attribute: {},
								formattedValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								}
							},
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'originNotTradableSecurities',
										defaultValue: null
									},
									id: 'securityFlags',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'baseModelWasDirty',
										defaultValue: null
									},
									id: 'dirtyFlag',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							{
								config: {
									label: null,
									infoBubble: null,
									extractor: {
										stores: [
											'details',
											'associatedPortfolios'
										],
										extractors: {
											PORTFOLIO: {
												storeConfig: [
													'details',
													'associatedPortfolios'
												]
											},
											MODEL_PORTFOLIO: {
												storeConfig: [
													'details'
												],
												expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
											},
											FALLBACK: {
												storeConfig: [
													'details'
												],
												expression: 'name'
											}
										},
										dataPaths: [
											'details,associatedPortfolios',
											'details,associatedPortfolios',
											'details,associatedPortfolios'
										]
									},
									id: 'name',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: 'ALL-SCENARIOS-CHECKOUT',
								parent: null,
								attribute: {},
								formattedValue: 'ALL-SCENARIOS-CHECKOUT'
							}
						]
					],
					portfolioData: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					firstColumnTitle: {
						config: null,
						rawValue: null,
						parent: null,
						attribute: {},
						formattedValue: null
					},
					transposed: false,
					rows: [
						{
							portfolioFlags: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'flags',
										defaultValue: null
									},
									id: 'portfolioFlags',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								},
								parent: null,
								attribute: {},
								formattedValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								}
							},
							securityFlags: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'originNotTradableSecurities',
										defaultValue: null
									},
									id: 'securityFlags',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							dirtyFlag: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'baseModelWasDirty',
										defaultValue: null
									},
									id: 'dirtyFlag',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							name: {
								config: {
									label: null,
									infoBubble: null,
									extractor: {
										stores: [
											'details',
											'associatedPortfolios'
										],
										extractors: {
											PORTFOLIO: {
												storeConfig: [
													'details',
													'associatedPortfolios'
												]
											},
											MODEL_PORTFOLIO: {
												storeConfig: [
													'details'
												],
												expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
											},
											FALLBACK: {
												storeConfig: [
													'details'
												],
												expression: 'name'
											}
										},
										dataPaths: [
											'details,associatedPortfolios',
											'details,associatedPortfolios',
											'details,associatedPortfolios'
										]
									},
									id: 'name',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: 'ALL-SCENARIOS-CHECKOUT',
								parent: null,
								attribute: {},
								formattedValue: 'ALL-SCENARIOS-CHECKOUT'
							}
						}
					]
				}
			],
			displayConfig: {
				active: true,
				visible: true,
				transpose: false,
				conditions: [],
				hideEmptyTab: false,
				clientOutput: null,
				isIterative: false,
				hideWithOtherTabs: false,
				isDominantTab: false
			}
		},
		{
			config: {
				id: 'portfolio.securities',
				title: null,
				extractorConfig: {
					portfolioName: {
						label: null,
						infoBubble: null,
						extractor: {
							stores: [
								'details',
								'associatedPortfolios'
							],
							extractors: {
								PORTFOLIO: {
									storeConfig: [
										'details',
										'associatedPortfolios'
									]
								},
								MODEL_PORTFOLIO: {
									storeConfig: [
										'details'
									],
									expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
								},
								FALLBACK: {
									storeConfig: [
										'details'
									],
									expression: 'name'
								}
							},
							dataPaths: [
								'details,associatedPortfolios',
								'details,associatedPortfolios',
								'details,associatedPortfolios'
							]
						},
						id: 'name',
						labelFormatter: {},
						formatters: [],
						visible: true
					},
					tableDataTransform: {},
					mapper: {
						storeDependencies: [
							'associatedPortfolios'
						],
						expression: 'associatedPortfolios.children'
					},
					firstColumnTitle: null,
					columns: [
						{
							label: null,
							extractor: {
								expression: 'uniqueId',
								defaultValue: ''
							},
							id: 'uniqueId',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'positionType',
								defaultValue: ''
							},
							id: 'positionType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifier',
								defaultValue: ''
							},
							id: 'identifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'commonIdentifier',
								defaultValue: ''
							},
							id: 'commonIdentifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifierType',
								defaultValue: ''
							},
							id: 'identifierType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'otherIdentifiers',
								defaultValue: ''
							},
							id: 'otherIdentifiers',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'weight',
								defaultValue: ''
							},
							id: 'weight',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'mappedFrom',
								defaultValue: ''
							},
							id: 'mappedFrom',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'originPlatform',
								defaultValue: ''
							},
							id: 'originPlatform',
							labelFormatter: {},
							formatters: [],
							visible: false
						}
					],
					childColumns: [
						{
							label: null,
							extractor: {
								expression: 'uniqueId',
								defaultValue: ''
							},
							id: 'uniqueId',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'positionType',
								defaultValue: ''
							},
							id: 'positionType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifier',
								defaultValue: ''
							},
							id: 'identifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'commonIdentifier',
								defaultValue: ''
							},
							id: 'commonIdentifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifierType',
								defaultValue: ''
							},
							id: 'identifierType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'otherIdentifiers',
								defaultValue: ''
							},
							id: 'otherIdentifiers',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'weight',
								defaultValue: ''
							},
							id: 'weight',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'mappedFrom',
								defaultValue: ''
							},
							id: 'mappedFrom',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'originPlatform',
								defaultValue: ''
							},
							id: 'originPlatform',
							labelFormatter: {},
							formatters: [],
							visible: false
						}
					]
				}
			},
			tableData: [
				{
					headersX: [
						{
							config: {
								label: null,
								extractor: {
									expression: 'uniqueId',
									defaultValue: ''
								},
								id: 'uniqueId',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'positionType',
									defaultValue: ''
								},
								id: 'positionType',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'identifier',
									defaultValue: ''
								},
								id: 'identifier',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'commonIdentifier',
									defaultValue: ''
								},
								id: 'commonIdentifier',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'identifierType',
									defaultValue: ''
								},
								id: 'identifierType',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'otherIdentifiers',
									defaultValue: ''
								},
								id: 'otherIdentifiers',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'weight',
									defaultValue: ''
								},
								id: 'weight',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'mappedFrom',
									defaultValue: ''
								},
								id: 'mappedFrom',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'originPlatform',
									defaultValue: ''
								},
								id: 'originPlatform',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						}
					],
					headersY: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					cells: [
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '383159ef-a789-46e8-bdde-2b7432488a56',
								parent: null,
								attribute: {},
								formattedValue: '383159ef-a789-46e8-bdde-2b7432488a56'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed',
								parent: null,
								attribute: {},
								formattedValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4',
								parent: null,
								attribute: {},
								formattedValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
								parent: null,
								attribute: {},
								formattedValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06dfe362-a87b-448a-a32e-1f9ae668abde',
								parent: null,
								attribute: {},
								formattedValue: '06dfe362-a87b-448a-a32e-1f9ae668abde'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '270892',
								parent: null,
								attribute: {},
								formattedValue: '270892'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'MODEL_ID',
								parent: null,
								attribute: {},
								formattedValue: 'MODEL_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth',
								parent: null,
								attribute: {},
								formattedValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'batk7a77-d605-4827-ac35-de6a6739c410',
								parent: null,
								attribute: {},
								formattedValue: 'batk7a77-d605-4827-ac35-de6a6739c410'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						]
					],
					portfolioData: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					firstColumnTitle: {
						config: null,
						rawValue: null,
						parent: null,
						attribute: {},
						formattedValue: null
					},
					transposed: false,
					rows: [
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '383159ef-a789-46e8-bdde-2b7432488a56',
								parent: null,
								attribute: {},
								formattedValue: '383159ef-a789-46e8-bdde-2b7432488a56'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed',
								parent: null,
								attribute: {},
								formattedValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4',
								parent: null,
								attribute: {},
								formattedValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
								parent: null,
								attribute: {},
								formattedValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06dfe362-a87b-448a-a32e-1f9ae668abde',
								parent: null,
								attribute: {},
								formattedValue: '06dfe362-a87b-448a-a32e-1f9ae668abde'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '270892',
								parent: null,
								attribute: {},
								formattedValue: '270892'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'MODEL_ID',
								parent: null,
								attribute: {},
								formattedValue: 'MODEL_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth',
								parent: null,
								attribute: {},
								formattedValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'batk7a77-d605-4827-ac35-de6a6739c410',
								parent: null,
								attribute: {},
								formattedValue: 'batk7a77-d605-4827-ac35-de6a6739c410'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						}
					]
				}
			],
			displayConfig: {
				active: true,
				visible: true,
				transpose: false,
				conditions: [],
				hideEmptyTab: false,
				clientOutput: null,
				isIterative: false,
				hideWithOtherTabs: false,
				isDominantTab: false
			}
		}
	],
	portfolioData: [
		[
			{
				config: {
					label: null,
					infoBubble: null,
					extractor: {
						stores: [
							'associatedPortfolios'
						],
						trueExtractor: {
							storeConfig: [
								'associatedPortfolios'
							],
							expression: 'otherIdentifiers'
						},
						falseExtractor: {
							storeConfig: [
								'associatedPortfolios'
							],
							expression: 'id'
						},
						dataPath: 'True: associatedPortfolios otherIdentifiers'
					},
					id: 'id',
					labelFormatter: {},
					formatters: [],
					visible: true
				},
				rawValue: [
					{
						identifier: '0100000AEEN015545373HAZM3FU3OWUFTBSHXKEXE4JTETUGOIX5YIYEBQGE7SOKSFMYSLRLQ====',
						customIdentifierType: 'ENVESTNET_HANDLE',
						'@type': '_bws.investments.IdentifierParam',
						identifierType: 'CUSTOM'
					}
				],
				attribute: {},
				formattedValue: [
					{
						identifier: '0100000AEEN015545373HAZM3FU3OWUFTBSHXKEXE4JTETUGOIX5YIYEBQGE7SOKSFMYSLRLQ====',
						customIdentifierType: 'ENVESTNET_HANDLE',
						'@type': '_bws.investments.IdentifierParam',
						identifierType: 'CUSTOM'
					}
				]
			},
			{
				config: {
					label: null,
					infoBubble: null,
					extractor: {
						storeConfig: [
							'associatedPortfolios'
						],
						expression: 'portfolioType'
					},
					id: 'portfolioType',
					labelFormatter: {},
					formatters: [],
					visible: true
				},
				attribute: {}
			},
			{
				config: {
					label: null,
					infoBubble: null,
					extractor: {
						storeConfig: [
							'associatedPortfolios'
						],
						expression: 'description'
					},
					id: 'description',
					labelFormatter: {},
					formatters: [],
					visible: true
				},
				rawValue: 'ALL-SCENARIOS-CHECKOUT',
				attribute: {},
				formattedValue: 'ALL-SCENARIOS-CHECKOUT'
			}
		]
	],
	isLoading: false,
	success: true,
	visible: true,
	tab: {
		'portfolio.flags': {
			config: {
				id: 'portfolio.flags',
				title: null,
				extractorConfig: {
					portfolioName: {
						label: null,
						infoBubble: null,
						extractor: {
							stores: [
								'details',
								'associatedPortfolios'
							],
							extractors: {
								PORTFOLIO: {
									storeConfig: [
										'details',
										'associatedPortfolios'
									]
								},
								MODEL_PORTFOLIO: {
									storeConfig: [
										'details'
									],
									expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
								},
								FALLBACK: {
									storeConfig: [
										'details'
									],
									expression: 'name'
								}
							},
							dataPaths: [
								'details,associatedPortfolios',
								'details,associatedPortfolios',
								'details,associatedPortfolios'
							]
						},
						id: 'name',
						labelFormatter: {},
						formatters: [],
						visible: true
					},
					tableDataTransform: {},
					firstColumnTitle: null,
					columns: [
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'flags',
								defaultValue: null
							},
							id: 'portfolioFlags',
							labelFormatter: {},
							formatters: [],
							visible: true
						},
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'originNotTradableSecurities',
								defaultValue: null
							},
							id: 'securityFlags',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								storeConfig: [
									'associatedPortfolios'
								],
								expression: 'baseModelWasDirty',
								defaultValue: null
							},
							id: 'dirtyFlag',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							infoBubble: null,
							extractor: {
								stores: [
									'details',
									'associatedPortfolios'
								],
								extractors: {
									PORTFOLIO: {
										storeConfig: [
											'details',
											'associatedPortfolios'
										]
									},
									MODEL_PORTFOLIO: {
										storeConfig: [
											'details'
										],
										expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
									},
									FALLBACK: {
										storeConfig: [
											'details'
										],
										expression: 'name'
									}
								},
								dataPaths: [
									'details,associatedPortfolios',
									'details,associatedPortfolios',
									'details,associatedPortfolios'
								]
							},
							id: 'name',
							labelFormatter: {},
							formatters: [],
							visible: true
						}
					]
				}
			},
			tableData: [
				{
					headersX: [
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'flags',
									defaultValue: null
								},
								id: 'portfolioFlags',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'originNotTradableSecurities',
									defaultValue: null
								},
								id: 'securityFlags',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									storeConfig: [
										'associatedPortfolios'
									],
									expression: 'baseModelWasDirty',
									defaultValue: null
								},
								id: 'dirtyFlag',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						}
					],
					headersY: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					cells: [
						[
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'flags',
										defaultValue: null
									},
									id: 'portfolioFlags',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								},
								parent: null,
								attribute: {},
								formattedValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								}
							},
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'originNotTradableSecurities',
										defaultValue: null
									},
									id: 'securityFlags',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							{
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'baseModelWasDirty',
										defaultValue: null
									},
									id: 'dirtyFlag',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							{
								config: {
									label: null,
									infoBubble: null,
									extractor: {
										stores: [
											'details',
											'associatedPortfolios'
										],
										extractors: {
											PORTFOLIO: {
												storeConfig: [
													'details',
													'associatedPortfolios'
												]
											},
											MODEL_PORTFOLIO: {
												storeConfig: [
													'details'
												],
												expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
											},
											FALLBACK: {
												storeConfig: [
													'details'
												],
												expression: 'name'
											}
										},
										dataPaths: [
											'details,associatedPortfolios',
											'details,associatedPortfolios',
											'details,associatedPortfolios'
										]
									},
									id: 'name',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: 'ALL-SCENARIOS-CHECKOUT',
								parent: null,
								attribute: {},
								formattedValue: 'ALL-SCENARIOS-CHECKOUT'
							}
						]
					],
					portfolioData: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					firstColumnTitle: {
						config: null,
						rawValue: null,
						parent: null,
						attribute: {},
						formattedValue: null
					},
					transposed: false,
					rows: [
						{
							portfolioFlags: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'flags',
										defaultValue: null
									},
									id: 'portfolioFlags',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								},
								parent: null,
								attribute: {},
								formattedValue: {
									originContainsEditableModel: true,
									originIsfirstTimeImported: true,
									originContainsUnsupportedSMA: true,
									inputWithValues: false,
									isProcessed: false,
									originContainsUnmatchedSecurities: true,
									originContainsUnsupportedManagedModel: true,
									originContainsAssetClassSubstitutions: true,
									originContainsSleeves: true
								}
							},
							securityFlags: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'originNotTradableSecurities',
										defaultValue: null
									},
									id: 'securityFlags',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							dirtyFlag: {
								config: {
									label: null,
									extractor: {
										storeConfig: [
											'associatedPortfolios'
										],
										expression: 'baseModelWasDirty',
										defaultValue: null
									},
									id: 'dirtyFlag',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: null,
								parent: null,
								attribute: {},
								formattedValue: null
							},
							name: {
								config: {
									label: null,
									infoBubble: null,
									extractor: {
										stores: [
											'details',
											'associatedPortfolios'
										],
										extractors: {
											PORTFOLIO: {
												storeConfig: [
													'details',
													'associatedPortfolios'
												]
											},
											MODEL_PORTFOLIO: {
												storeConfig: [
													'details'
												],
												expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
											},
											FALLBACK: {
												storeConfig: [
													'details'
												],
												expression: 'name'
											}
										},
										dataPaths: [
											'details,associatedPortfolios',
											'details,associatedPortfolios',
											'details,associatedPortfolios'
										]
									},
									id: 'name',
									labelFormatter: {},
									formatters: [],
									visible: true
								},
								rawValue: 'ALL-SCENARIOS-CHECKOUT',
								parent: null,
								attribute: {},
								formattedValue: 'ALL-SCENARIOS-CHECKOUT'
							}
						}
					]
				}
			],
			displayConfig: {
				active: true,
				visible: true,
				transpose: false,
				conditions: [],
				hideEmptyTab: false,
				clientOutput: null,
				isIterative: false,
				hideWithOtherTabs: false,
				isDominantTab: false
			}
		},
		'portfolio.securities': {
			config: {
				id: 'portfolio.securities',
				title: null,
				extractorConfig: {
					portfolioName: {
						label: null,
						infoBubble: null,
						extractor: {
							stores: [
								'details',
								'associatedPortfolios'
							],
							extractors: {
								PORTFOLIO: {
									storeConfig: [
										'details',
										'associatedPortfolios'
									]
								},
								MODEL_PORTFOLIO: {
									storeConfig: [
										'details'
									],
									expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
								},
								FALLBACK: {
									storeConfig: [
										'details'
									],
									expression: 'name'
								}
							},
							dataPaths: [
								'details,associatedPortfolios',
								'details,associatedPortfolios',
								'details,associatedPortfolios'
							]
						},
						id: 'name',
						labelFormatter: {},
						formatters: [],
						visible: true
					},
					tableDataTransform: {},
					mapper: {
						storeDependencies: [
							'associatedPortfolios'
						],
						expression: 'associatedPortfolios.children'
					},
					firstColumnTitle: null,
					columns: [
						{
							label: null,
							extractor: {
								expression: 'uniqueId',
								defaultValue: ''
							},
							id: 'uniqueId',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'positionType',
								defaultValue: ''
							},
							id: 'positionType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifier',
								defaultValue: ''
							},
							id: 'identifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'commonIdentifier',
								defaultValue: ''
							},
							id: 'commonIdentifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifierType',
								defaultValue: ''
							},
							id: 'identifierType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'otherIdentifiers',
								defaultValue: ''
							},
							id: 'otherIdentifiers',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'weight',
								defaultValue: ''
							},
							id: 'weight',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'mappedFrom',
								defaultValue: ''
							},
							id: 'mappedFrom',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'originPlatform',
								defaultValue: ''
							},
							id: 'originPlatform',
							labelFormatter: {},
							formatters: [],
							visible: false
						}
					],
					childColumns: [
						{
							label: null,
							extractor: {
								expression: 'uniqueId',
								defaultValue: ''
							},
							id: 'uniqueId',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'positionType',
								defaultValue: ''
							},
							id: 'positionType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifier',
								defaultValue: ''
							},
							id: 'identifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'commonIdentifier',
								defaultValue: ''
							},
							id: 'commonIdentifier',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'identifierType',
								defaultValue: ''
							},
							id: 'identifierType',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'otherIdentifiers',
								defaultValue: ''
							},
							id: 'otherIdentifiers',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'weight',
								defaultValue: ''
							},
							id: 'weight',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'mappedFrom',
								defaultValue: ''
							},
							id: 'mappedFrom',
							labelFormatter: {},
							formatters: [],
							visible: false
						},
						{
							label: null,
							extractor: {
								expression: 'originPlatform',
								defaultValue: ''
							},
							id: 'originPlatform',
							labelFormatter: {},
							formatters: [],
							visible: false
						}
					]
				}
			},
			tableData: [
				{
					headersX: [
						{
							config: {
								label: null,
								extractor: {
									expression: 'uniqueId',
									defaultValue: ''
								},
								id: 'uniqueId',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'positionType',
									defaultValue: ''
								},
								id: 'positionType',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'identifier',
									defaultValue: ''
								},
								id: 'identifier',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'commonIdentifier',
									defaultValue: ''
								},
								id: 'commonIdentifier',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'identifierType',
									defaultValue: ''
								},
								id: 'identifierType',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'otherIdentifiers',
									defaultValue: ''
								},
								id: 'otherIdentifiers',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'weight',
									defaultValue: ''
								},
								id: 'weight',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'mappedFrom',
									defaultValue: ''
								},
								id: 'mappedFrom',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						},
						{
							config: {
								label: null,
								extractor: {
									expression: 'originPlatform',
									defaultValue: ''
								},
								id: 'originPlatform',
								labelFormatter: {},
								formatters: [],
								visible: false
							},
							rawValue: null,
							parent: null,
							attribute: {
								infoBubble: null
							},
							formattedValue: null
						}
					],
					headersY: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					cells: [
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '383159ef-a789-46e8-bdde-2b7432488a56',
								parent: null,
								attribute: {},
								formattedValue: '383159ef-a789-46e8-bdde-2b7432488a56'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed',
								parent: null,
								attribute: {},
								formattedValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4',
								parent: null,
								attribute: {},
								formattedValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
								parent: null,
								attribute: {},
								formattedValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06dfe362-a87b-448a-a32e-1f9ae668abde',
								parent: null,
								attribute: {},
								formattedValue: '06dfe362-a87b-448a-a32e-1f9ae668abde'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '270892',
								parent: null,
								attribute: {},
								formattedValue: '270892'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'MODEL_ID',
								parent: null,
								attribute: {},
								formattedValue: 'MODEL_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth',
								parent: null,
								attribute: {},
								formattedValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								}
							}
						],
						[
							{
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'batk7a77-d605-4827-ac35-de6a6739c410',
								parent: null,
								attribute: {},
								formattedValue: 'batk7a77-d605-4827-ac35-de6a6739c410'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								]
							},
							{
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						]
					],
					portfolioData: [
						{
							config: {
								label: null,
								infoBubble: null,
								extractor: {
									stores: [
										'details',
										'associatedPortfolios'
									],
									extractors: {
										PORTFOLIO: {
											storeConfig: [
												'details',
												'associatedPortfolios'
											]
										},
										MODEL_PORTFOLIO: {
											storeConfig: [
												'details'
											],
											expression: 'modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation'
										},
										FALLBACK: {
											storeConfig: [
												'details'
											],
											expression: 'name'
										}
									},
									dataPaths: [
										'details,associatedPortfolios',
										'details,associatedPortfolios',
										'details,associatedPortfolios'
									]
								},
								id: 'name',
								labelFormatter: {},
								formatters: [],
								visible: true
							},
							rawValue: 'ALL-SCENARIOS-CHECKOUT',
							parent: null,
							attribute: {},
							formattedValue: 'ALL-SCENARIOS-CHECKOUT'
						}
					],
					firstColumnTitle: {
						config: null,
						rawValue: null,
						parent: null,
						attribute: {},
						formattedValue: null
					},
					transposed: false,
					rows: [
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'BD-IPB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Inflation-Protected Bond',
									type: 'ASSET_CLASS'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'TIP@464287176@US4642871762',
								parent: null,
								attribute: {},
								formattedValue: 'TIP@464287176@US4642871762'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '383159ef-a789-46e8-bdde-2b7432488a56',
								parent: null,
								attribute: {},
								formattedValue: '383159ef-a789-46e8-bdde-2b7432488a56'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'IJR@464287804@US4642878049',
								parent: null,
								attribute: {},
								formattedValue: 'IJR@464287804@US4642878049'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed',
								parent: null,
								attribute: {},
								formattedValue: 'a17d06d2-5392-4024-9c4b-c64205edb3ed'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4',
								parent: null,
								attribute: {},
								formattedValue: 'b5a3285d-97e9-4ec3-9348-aa87109eb4f4'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
								parent: null,
								attribute: {},
								formattedValue: 'e2e2551a-f70b-4daa-a4ba-d2157956313d'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'AS-1483',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 20,
								parent: null,
								attribute: {},
								formattedValue: 20
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'APM Sleeve Model',
									type: 'APM_SLEEVE'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06dfe362-a87b-448a-a32e-1f9ae668abde',
								parent: null,
								attribute: {},
								formattedValue: '06dfe362-a87b-448a-a32e-1f9ae668abde'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'VALID',
								parent: null,
								attribute: {},
								formattedValue: 'VALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '270892',
								parent: null,
								attribute: {},
								formattedValue: '270892'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'MODEL_ID',
								parent: null,
								attribute: {},
								formattedValue: 'MODEL_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSP3010',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Model Portfolio 10/90',
									type: 'MANAGED_MODEL'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '06fe8362-a87b-448a-a32e-1f9ae668abae',
								parent: null,
								attribute: {},
								formattedValue: '06fe8362-a87b-448a-a32e-1f9ae668abae'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'FSPLMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'ClearBridge Large Cap Growth ESG',
									type: 'MANAGED_MODEL'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'a1f67a77-d605-4827-ac35-de6a6739c439',
								parent: null,
								attribute: {},
								formattedValue: 'a1f67a77-d605-4827-ac35-de6a6739c439'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth',
								parent: null,
								attribute: {},
								formattedValue: '0dcb8362-a87b-448a-a32e-1f9ae668arth'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'INVALID',
								parent: null,
								attribute: {},
								formattedValue: 'INVALID'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
								parent: null,
								attribute: {},
								formattedValue: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CUSTOM',
								parent: null,
								attribute: {},
								formattedValue: 'CUSTOM'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								parent: null,
								attribute: {},
								formattedValue: [
									{
										identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'ACM-LMCBSLG',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								]
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								},
								parent: null,
								attribute: {},
								formattedValue: {
									name: 'Separately Managed Model',
									type: 'SMA'
								}
							}
						},
						{
							uniqueId: {
								config: {
									label: null,
									extractor: {
										expression: 'uniqueId',
										defaultValue: ''
									},
									id: 'uniqueId',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'batk7a77-d605-4827-ac35-de6a6739c410',
								parent: null,
								attribute: {},
								formattedValue: 'batk7a77-d605-4827-ac35-de6a6739c410'
							},
							positionType: {
								config: {
									label: null,
									extractor: {
										expression: 'positionType',
										defaultValue: ''
									},
									id: 'positionType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SUBSTITUTED',
								parent: null,
								attribute: {},
								formattedValue: 'SUBSTITUTED'
							},
							identifier: {
								config: {
									label: null,
									extractor: {
										expression: 'identifier',
										defaultValue: ''
									},
									id: 'identifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							commonIdentifier: {
								config: {
									label: null,
									extractor: {
										expression: 'commonIdentifier',
										defaultValue: ''
									},
									id: 'commonIdentifier',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'CASH-USD@XUSD00000@',
								parent: null,
								attribute: {},
								formattedValue: 'CASH-USD@XUSD00000@'
							},
							identifierType: {
								config: {
									label: null,
									extractor: {
										expression: 'identifierType',
										defaultValue: ''
									},
									id: 'identifierType',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 'SECURITY_ID',
								parent: null,
								attribute: {},
								formattedValue: 'SECURITY_ID'
							},
							otherIdentifiers: {
								config: {
									label: null,
									extractor: {
										expression: 'otherIdentifiers',
										defaultValue: ''
									},
									id: 'otherIdentifiers',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							},
							weight: {
								config: {
									label: null,
									extractor: {
										expression: 'weight',
										defaultValue: ''
									},
									id: 'weight',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: 10,
								parent: null,
								attribute: {},
								formattedValue: 10
							},
							mappedFrom: {
								config: {
									label: null,
									extractor: {
										expression: 'mappedFrom',
										defaultValue: ''
									},
									id: 'mappedFrom',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								],
								parent: null,
								attribute: {},
								formattedValue: [
									'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB===='
								]
							},
							originPlatform: {
								config: {
									label: null,
									extractor: {
										expression: 'originPlatform',
										defaultValue: ''
									},
									id: 'originPlatform',
									labelFormatter: {},
									formatters: [],
									visible: false
								},
								rawValue: '',
								parent: null,
								attribute: {},
								formattedValue: ''
							}
						}
					]
				}
			],
			displayConfig: {
				active: true,
				visible: true,
				transpose: false,
				conditions: [],
				hideEmptyTab: false,
				clientOutput: null,
				isIterative: false,
				hideWithOtherTabs: false,
				isDominantTab: false
			}
		}
	}
};
